import { api } from '@/lib/api';

export type SimplePodcastEpisode = {
  id: string;
  title: string;
  description: string;
  status: 'draft' | 'published';
  audioDurationSeconds: number | null;
  audioUrl: string | null;
  coverImageUrl: string | null;
  position: number;
  createdAt: string;
  updatedAt: string;
};

export type SimplePodcastPayload = {
  id: string;
  title: string;
  description: string;
  language: string;
  creationMode: 'simple';
  episodeSortOrder: 'newest_first' | 'oldest_first';
  episodes: SimplePodcastEpisode[];
};

function unwrap<T>(raw: unknown): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return (raw as { data: T }).data;
  }
  return raw as T;
}

export const podcastSimpleApi = {
  get: (podcastId: string) =>
    api.get<SimplePodcastPayload>(`/podcasts/${podcastId}/simple`).then(unwrap),

  update: (podcastId: string, data: { title?: string; description?: string }) =>
    api.put<{ id: string; title: string; description: string }>(`/podcasts/${podcastId}/simple`, data).then(unwrap),

  createEpisode: (podcastId: string, data?: { title?: string; description?: string }) =>
    api
      .post<SimplePodcastEpisode>(`/podcasts/${podcastId}/simple/episodes`, data ?? {})
      .then(unwrap),

  reorderEpisodes: (podcastId: string, episodeIds: string[]) =>
    api
      .put<{ ok: boolean }>(`/podcasts/${podcastId}/simple/episodes/reorder`, { episodeIds })
      .then(unwrap),

  deleteEpisode: (podcastId: string, episodeId: string) =>
    api
      .delete<{ deleted: boolean }>(`/podcasts/${podcastId}/simple/episodes/${episodeId}`)
      .then(unwrap),
};

export function getPodcastEditPath(podcast: { id: string; creationMode?: string | null }): string {
  if (podcast.creationMode === 'simple') return `/podcasts/simple/${podcast.id}`;
  return '/podcasts';
}

export function getSimpleEpisodeEditorPath(podcastId: string, episodeId: string): string {
  return `/podcasts/simple/${podcastId}/episodes/${episodeId}`;
}

/** Éditeur complexe (IA, chapitres, voix) depuis un podcast simple — retour via simplePodcastId. */
export function getAdvancedEpisodeEditorPath(podcastId: string, episodeId: string): string {
  return `/podcasts/episodes/${episodeId}?simplePodcastId=${encodeURIComponent(podcastId)}`;
}
